import { 
  signInWithEmailAndPassword,
  signOut,
  onAuthStateChanged,
  createUserWithEmailAndPassword
} from 'firebase/auth';
import { auth } from './config';

// Sign in admin user
export const signInAdmin = async (email, password) => {
  try {
    const userCredential = await signInWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error('Sign in error:', error);
    return { success: false, error: error.message };
  }
};

// Sign out user
export const signOutUser = async () => {
  try {
    await signOut(auth);
    return { success: true };
  } catch (error) {
    console.error('Sign out error:', error);
    return { success: false, error: error.message };
  }
};

// Create admin user (for initial setup only)
export const createAdmin = async (email, password) => {
  try {
    const userCredential = await createUserWithEmailAndPassword(auth, email, password);
    return { success: true, user: userCredential.user };
  } catch (error) {
    console.error('Create user error:', error);
    return { success: false, error: error.message };
  }
};

// Auth state observer
export const observeAuthState = (callback) => {
  return onAuthStateChanged(auth, callback);
};

// Check if user is admin (you can implement custom claims or check against a specific email)
export const isAdminUser = (user) => {
  if (!user) return false;
  
  // Method 1: Check against admin email
  const adminEmails = [process.env.REACT_APP_ADMIN_EMAIL];
  
  // Method 2: Check custom claims (requires Firebase Admin SDK setup)
  // return user.getIdTokenResult().then(idTokenResult => {
  //   return !!idTokenResult.claims.admin;
  // });
  
  return adminEmails.includes(user.email);
};